import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const aerialFieldDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "aerial-field-detect-example",
  version: 1,
  title: "Aerial imagery",
  description: "Count aircraft from above",
  subdescription: "Detect every airplane across an airport in one overhead shot.",
  thumbnailUuid: BASE_ASSETS.brisbaneAirportAerialExample.uuid,
  assets: [BASE_ASSETS.brisbaneAirportAerialExample],
  detect: {
    mediaUuid: BASE_ASSETS.brisbaneAirportAerialExample.uuid,
    categories: ["airplanes", "jet bridges"],
    config: {
      output: "box",
    },
  },
};
